import { render } from "./Taint.vue?vue&type=template&id=7a4be906&ts=true"
import script from "./Taint.vue?vue&type=script&lang=ts"
export * from "./Taint.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__